// Explanatory text only. Validation and all numerical decisions remain on the backend.
// Describes the current contract; IC-1 text is reference-only and does not approve a laboratory SOP.
import { IC_RepeatabilityDecision } from '../../Interface/IC_Interface';
export function icDecisionBasis(type: string, method: string, acceptance: string, version = 'IC-2', contract?: IC_RepeatabilityDecision | null): string {
  if (contract) {
    if (version !== 'IC-2' || type !== 'REPEATABILITY' || contract.ruleVersion !== 'IC-2-REPEATABILITY-V1'
        || !['SampleSD', 'ReadingRange'].includes(contract.quantity) || !['MAX', 'RANGE'].includes(contract.comparison)
        || method !== (contract.quantity === 'SampleSD' ? 'STD_DEV' : 'RANGE') || acceptance !== contract.comparison)
      return 'نسخه قرارداد تکرارپذیری پشتیبانی نمی‌شود؛ ارزیابی سرور الزامی است.';
    return `${contract.ruleVersion}: مبنای تصمیم ${contract.quantity === 'SampleSD' ? 'انحراف معیار نمونه (SampleSD)' : 'دامنه قرائت‌ها (ReadingRange)'} با حدود صریح ${contract.comparison} است؛ این حدود مربوط به میانگین نیستند. ثبت عمومی این نسخه تا تصویب روش مسدود است.`;
  }
  if (version === 'IC-2' && type === 'NUMERIC' && method === 'MEAN' && ['MAX', 'MIN', 'RANGE'].includes(acceptance)) {
    return 'IC-2: مبنای تصمیم، میانگین حسابی قرائت‌های واقعی (Mean) و حدود تعریف‌شده برای همان میانگین است؛ مقدار مستقیم جایگزین آن نمی‌شود.';
  }
  const bounds = ['MAX', 'MIN', 'RANGE'];
  const review = ' تغییر مبنای تصمیم نیازمند تصویب روش و حدود پذیرش است.';
  if (['CHECK', 'PASS_FAIL', 'TEXT'].includes(type) && method === 'NONE' && acceptance === 'MANUAL') {
    return type === 'TEXT' ? 'مشاهده متنی؛ نتیجه فعلی NA است.' : 'تصمیم فعلی بر وضعیت انطباق ثبت‌شده است.';
  }
  if (type === 'NUMERIC' && ['NONE', 'MEAN'].includes(method) && bounds.includes(acceptance)) {
    return 'مبنای تصمیم فعلی: مقدار واردشده (Measured).'
      + (method === 'MEAN' ? ' در IC-1 با انتخاب MEAN نیز میانگین قرائت‌ها در این مسیر محاسبه نمی‌شود.'
        + ' این توضیح فقط مرجع IC-1 است و مسیر ایجاد اجرای جدید نیست.' + review : '');
  }
  if (type === 'NUMERIC_WITH_REFERENCE' && ['DIFFERENCE', 'ABS_DIFFERENCE', 'PERCENT_DIFFERENCE'].includes(method)) {
    if (bounds.includes(acceptance)) {
      return 'مبنای تصمیم فعلی: مقدار واردشده (Measured)، در مقایسه با حدود؛ اختلاف نمایشی مبنای این تصمیم نیست.'
        + (version === 'IC-2' ? ' این رفتار مطابق قرارداد تأییدشده محصول است؛ روش ارزیابی مقدار اختلاف نمایشی را تعیین می‌کند.' : review);
    }
    if (acceptance === 'ABS_DIFFERENCE') return 'مبنای تصمیم فعلی: قدر مطلق اختلاف با مرجع (AbsoluteDifference)، در مقایسه با حد اختلاف.';
    if (acceptance === 'PERCENT_DIFFERENCE') return 'مبنای تصمیم فعلی: قدر مطلق اختلاف درصدی (AbsolutePercent)، در مقایسه با حد درصدی؛ مرجع باید غیرصفر باشد.';
  }
  if (type === 'REPEATABILITY' && ['NONE', 'MEAN', 'STD_DEV', 'RANGE'].includes(method)) {
    if (acceptance === 'STD_DEV') {
      return 'مبنای تصمیم فعلی: انحراف معیار نمونه (SD)؛ مقدار محاسبه‌شده نمایشی، میانگین است.'
        + (method !== 'STD_DEV' ? ' روش انتخاب‌شده با شاخص تصمیم یکسان نیست.' + review : '');
    }
    if (bounds.includes(acceptance)) {
      return 'مبنای تصمیم فعلی: میانگین قرائت‌ها (Mean)، در مقایسه با حدود.'
        + (method !== 'MEAN' ? ' روش انتخاب‌شده شاخص تصمیم را تغییر نمی‌دهد.' + review : '');
    }
  }
  if (type === 'TRUENESS_BIAS' && ['NONE', 'TRUENESS_BIAS'].includes(method)
      && ['MANUAL', 'STATISTICAL_TRUENESS'].includes(acceptance)) {
    return 'مبنای تصمیم فعلی: قدر مطلق اریبی (Delta)، در مقایسه با حد سازگاری (AcceptanceLimit)؛ آمار t مبنای PASS/FAIL نیست.';
  }
  return 'این ترکیب در قرارداد فعلی پشتیبانی نمی‌شود؛ اعتبارسنجی سرور ملاک ثبت است. روش و معیار سازگار انتخاب کنید.';
}
